<template>
  <div class="component-body">
    <div role="tooltip" x-placement="top" id="el-popover-2936" aria-hidden="true" tabindex="0"
         class="el-popover el-popper el-popover--plain" style="width: 200px; position: relative;">
      <div class="el-popover__title">Title</div>
      this is content, this is content, this is content
      <div x-arrow="" class="popper__arrow"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'index'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/components/30/Popover/index.vue